module.exports = __webpack_public_path__ + "img/seguro.83105257.jpeg";